/**
 * message/index.js
 *
 * @author hayakawa 2023.12.05
 */

// インポート
import { auto_show_time, auto_hide_time } from '../../_constants';

// 定数
const $flash_message = $('#flash-message'),                                                                     // 実行結果表示場所
    $modal_message_index = $('#modal-message-index'),             // Indexモーダル
    $section_message_list = $('.message-index-left-list'),          // 一覧セクション
    $section_message_tabs = $('.message-index-left-tabs'),          // タブセクション
    $section_message_buttons = $('.message-index-left-buttons'),    // ボタンセクション
    $form_message_list = $('#form-message-list'),                   // 一覧フォーム
    $section_message_tips = $('.message-index-right-tips'),         // Tipsセクション
    $section_message_preview = $('.message-index-right-preview'),   // プレビューセクション
    $form_message_preview = $('#form-message-preview'),             // プレビューフォーム
    $section_message_display = $('#message-display'),               // 表示セクション
    $modal_add_message = $('#modal-add-message'),                   // メッセージ追加モーダル
    $form_add_message = $('#form-add-message'),                     // メッセージ追加フォーム
    $modal_reply_message = $('#modal_reply-message'),               // メッセージ返信モーダル
    $form_reply_message = $('#form_reply-message'),                 // メッセージ返信フォーム
    $modal_add_negotiation = $('#modal-add-negotiation'),           // 交渉追加モーダル
    $form_add_negotiation = $('#form-add-negotiation'),             // 交渉追加フォーム
    $modal_check_negotiation = $('#modal-check-negotiation'),       // 交渉確認モーダル
    modal_result = $('#modal-result'),                              // 結果モーダル
    $modal_validation = $('#modal-validation'),
    spinner = '<i class="fas fa-spinner fa-spin"></i>',             // スピナー
    answer_class_help = 1,                                          // 返信区分 (ヘルプ)
    answer_class_only_reply = 2,                                    // 返信区分 (返信のみ)
    answer_class_three_choices = 3,                                 // 返信区分 (3択)
    z_idx_top = 1050,                                               // モーダル表示用
    z_idx_back = 1030,                                              // モーダル隠し用
    is_sv = $form_message_list.find('input[name="is_sv"]').val() === '1',
    belongs_organization_id = $form_message_list.find('input[name="belongs_organization_id"]').val();
let disp_other_organization = belongs_organization_id !== $('#message-organization-id').val(),
    can_not_edit = is_sv && disp_other_organization;

// 処理
$(function() {
    // スクロール領域
    $section_message_list.css('height', window.innerHeight * 0.7);
    $section_message_preview.css('height', window.innerHeight * 0.8);

    // デイトピッカー発動
    $('.dtpk.ymd-slash').datetimepicker({
        format: 'YYYY/MM/DD',
        icons: {
            time: 'far fa-clock'
        },
        viewMode: 'days',
        locale: 'ja',
        dayViewHeaderFormat: 'YYYY年MM月',
        useCurrent: false,
        defaultDate: false,
        widgetPositioning: {
            horizontal: "auto",
            vertical: "bottom"
        },
    });

    // フォーカスアウトでデイトピッカー閉じる
    $('.dtpk.ymd-slash').on('blur', function() {
        $('.dtpk.ymd-slash').datetimepicker('hide');
    });

    // 吹き出しクリック
    $('#btn-show-message-index').on('click', function() {
        if ($(this).hasClass('is-view-mode')) {
            return false;
        }
        $form_message_list.find('[name=sort_target]').val('');
        $form_message_list.find('[name=sort_mode]').val('');
        makeMessageList($(this));
    });

    // 企業変更
    $('#message-company-id').on('change', function() {
        const company_id = $(this).val(),
            params = new URLSearchParams();
        params.append('company_id', company_id);
        params.append('mode', 'charges');
        axios.get(`${GET_ORGANIZATIONS_API_ENDPOINT}?${params.toString()}`)
        .then(res => {
            console.log(res);
            const data = res.data,
                organizations = data.organizations,
                organization_id = (organizations.length > 0) ? organizations[0].organization_id : 0;
            let html = '';
            $.each(organizations, function(k, v) {
                html += `<option value="${v.organization_id}">${v.organization_name}</option>\n`;
            });
            $('#message-organization-id').html(html);
            $form_message_list.find('[name=sort_target]').val('');
            $form_message_list.find('[name=sort_mode]').val('');
            $modal_message_index.find('[name=company_id]').val(company_id);
            $modal_message_index.find('[name=organization_id]').val(organization_id);
            $form_add_message.find('[name=organization_id]').val(organization_id);
            $form_add_negotiation.find('[name=organization_id]').val(organization_id);
            if (organization_id) {
                makeMessageList();
                disp_other_organization = belongs_organization_id !== organization_id;
                can_not_edit = is_sv && disp_other_organization;
            }
        })
        .catch(err => {
            console.log(err);
            alert(err);
        })
        .finally(() => {
        })
    });

    // 店舗変更
    $('#message-organization-id').on('change', function() {
        const organization_id = $(this).val();
        $form_message_list.find('[name=sort_target]').val('');
        $form_message_list.find('[name=sort_mode]').val('');
        $modal_message_index.find('[name=organization_id]').val(organization_id);
        $form_add_message.find('[name=organization_id]').val(organization_id);
        $form_add_negotiation.find('[name=organization_id]').val(organization_id);
        makeMessageList();
        disp_other_organization = belongs_organization_id !== organization_id;
        can_not_edit = is_sv && disp_other_organization;
    });

    // タブクリック
    $('.btn-tab').on('click', function() {
        const has_active = $(this).hasClass('active'),
            tab = $(this).attr('data-tab');
        if (!has_active) {
            $form_message_list.find('[name=sort_target]').val('');
            $form_message_list.find('[name=sort_mode]').val('');
            $form_message_list.find('[name=tab_class]').val(tab);
            makeMessageList($(this));
        }
    });

    // フィルタークリック
    $('.btn-filter').on('click', function() {
        const has_active = $(this).hasClass('active'),
            filter = $(this).attr('data-filter');
        if (!has_active) {
            $form_message_list.find('[name=filter_class]').val(filter);
            makeMessageList($(this));
        }
    });

    // ソート
    $section_message_list.find('thead').find('button').on('click', function() {
        const target = $(this).attr('data-target'),
            mode = $(this).attr('data-mode');
        $form_message_list.find('[name=sort_target]').val(target);
        $form_message_list.find('[name=sort_mode]').val(mode);
        makeMessageList($(this));
    });

    // 選択モード変更
    $('.btn-change-select-mode').on('click', function() {
        if (can_not_edit) {
            return false;
        }

        const disabled = $(this).hasClass('disabled'),
            $table = $(this).closest('table'),
            $checkboxs = $table.find('div.chk-custom'),
            old_select_mode = $form_message_list.find('[name=select_mode]').val(),
            new_select_mode = (old_select_mode) ? '' : '1';
        if (!disabled) {
            if (new_select_mode) {
                $checkboxs.show();
                $section_message_preview.hide();
                $section_message_tips.show();
                $(this).find('.img-active').show();
                $(this).find('.img-inactive').hide();
            } else {
                $checkboxs.find('input[type="checkbox"]').prop('checked', false);
                $checkboxs.hide();
                $table.find('tr').removeClass('active');
                $(this).find('.img-active').hide();
                $(this).find('.img-inactive').show();
            }
            $form_message_list.find('[name=select_mode]').val(new_select_mode);
            controlBtnActivate();
        }
    });

    // 行クリック
    $(document).on('click', '.message-index-left-list tbody tr', function() {
        const tab_class = $form_message_list.find('[name=tab_class]').val(),
            has_active = $(this).hasClass('active'),
            target_name = $(this).find('.name').text(),
            target_id = $(this).data('target_id'),
            $table = $(this).closest('table'),
            $checkbox = $(this).find('input[type=checkbox]'),
            select_mode = $form_message_list.find('[name=select_mode]').val();

        if (select_mode) {
            if (!has_active) {
                $(this).addClass('active');
                $checkbox.prop('checked', true);
            } else {
                $(this).removeClass('active');
                $checkbox.prop('checked', false);
            }
        } else {
            if (!has_active) {
                // left
                $table.find('tr').removeClass('active');
                $table.find('input[type=checkbox]').prop('checked', false);
                $(this).addClass('active');
                $checkbox.prop('checked', true);
                if (tab_class === 'group') {
                    $form_message_list.find('[name=message_group_id]').val(target_id);
                    $form_message_list.find('[name=employee_id]').val('');
                    $form_message_preview.find('[name=message_group_id]').val(target_id);
                    $form_message_preview.find('[name=employee_id]').val('');
                } else {
                    $form_message_list.find('[name=message_group_id]').val('');
                    $form_message_list.find('[name=employee_id]').val(target_id);
                    $form_message_preview.find('[name=message_group_id]').val('');
                    $form_message_preview.find('[name=employee_id]').val(target_id);
                }
                // right
                $section_message_preview.find('.thread-name').text(target_name);
                makeThread($(this));
            } else {
                $(this).removeClass('active');
                $checkbox.prop('checked', false);
                $section_message_preview.hide();
                $section_message_tips.show();
            }
        }
        controlBtnActivate();
    });

    // チェックボックスクリック
    $(document).on('click', '.message-index-left-list .chk-custom label', function(e) {
        const select_mode = $form_message_list.find('[name=select_mode]').val();
        if (!select_mode) {
            e.stopPropagation();
        } else {
            $(this).closest('tr').click();
        }
    });

    // 各ボタンクリック
    $(document).on('click', '.answer-buttons button', function() {
        const $li = $(this).closest('li'),
            message_id = $li.attr('data-message_id'),
            work_date = $li.attr('data-work_date'),
            is_help = $(this).hasClass('help') ? true : false,
            is_yes = $(this).hasClass('yes') ? true : false,
            is_no = $(this).hasClass('no') ? true : false,
            is_change = $(this).hasClass('change') ? true : false,
            type = 'message',
            mode = (is_yes) ? 'yes' : ((is_no) ? 'no' : 'change');
        $form_message_preview.find('[name=message_id]').val(message_id);
        $form_message_preview.find('[name=type]').val(type);
        $form_message_preview.find('[name=mode]').val(mode);
        $form_message_preview.find('[name=work_date]').val(work_date);
        // help
        if (is_help) {
            const employee_id = $form_message_preview.find('[name=employee_id]').val(),
                $form_data = new FormData($form_message_preview.get(0)),
                params = new URLSearchParams($form_data),
                $btn = $('button'),
                btn_html = $(this).html();
            // change
            if (mode === 'change') {
                $btn.prop('disabled', true);
                $(this).html(spinner);
                axios.get(`${GET_NEGOTIATION_API_ENDPOINT}?${params.toString()}`)
                .then(res => {
                    const data = res.data,
                        message = data.message,
                        organization_name = data.organization_name,
                        work_type = data.work_type,
                        work_date = data.work_date,
                        work_date_week = data.work_date_week,
                        work_time_from = data.work_time_from,
                        work_time_to = data.work_time_to,
                        now = getNow(),
                        start_time = $form_add_negotiation.find('[name=start_time]').val(),
                        end_time = $form_add_negotiation.find('[name=end_time]').val(),
                        input_time_step = $form_add_negotiation.find('[name=input_time_step]').val(),
                        start_time_h = Number(start_time.substr(0, 2)),
                        end_time_h = Number(end_time.substr(0, 2));
                    let html = '' +
                        `・店舗 ${organization_name}<br>\n` +
                        `・職種 ${work_type}<br>\n` +
                        `・日付 ${work_date} ${work_date_week}<br>\n` +
                        `・時間 ` +
                        `<select class="form-control form-control-sm d-inline-block w-10em bg-white" id="work-time-from-negotiation" name="work_time_from">\n`;
                    for (let i = start_time_h; i <= end_time_h; i ++) {
                        const val = (i < 10) ? `0${i}` : String(i),
                            selected_00 = (`${val}:00` === work_time_from) ? ' selected' : '',
                            selected_30 = (`${val}:30` === work_time_from) ? ' selected' : '';
                        html += `<option value="${val}:00"${selected_00}>${val}:00</option>\n`;
                        if (i !== end_time_h) {
                            html += `<option value="${val}:30"${selected_30}>${val}:30</option>\n`;
                        }
                    }
                    html += '' +
                        `</select>\n` +
                        ` ～ ` +
                        `<select class="form-control form-control-sm d-inline-block w-10em bg-white" id="work-time-to-negotiation" name="work_time_to">\n`;
                    for (let i = start_time_h; i <= end_time_h; i ++) {
                        const val = (i < 10) ? `0${i}` : String(i),
                            selected_00 = (`${val}:00` === work_time_to) ? ' selected' : '',
                            selected_30 = (`${val}:30` === work_time_to) ? ' selected' : '';
                        html += `<option value="${val}:00"${selected_00}>${val}:00</option>\n`;
                        if (i !== end_time_h) {
                            html += `<option value="${val}:30"${selected_30}>${val}:30</option>\n`;
                        }
                    }
                    html += '' +
                        `</select>\n` +
                        `で出勤していただけないでしょうか。よろしくお願いします。\n`;
                    $form_add_negotiation.find('.is-invalid').removeClass('is-invalid');
                    $form_add_negotiation.find('.invalid-feedback').text('');
                    $modal_add_negotiation.find('.exec-result-message').html('').hide();
                    $form_add_negotiation.find('[name=message_id]').val(message_id);
                    $form_add_negotiation.find('[name=employee_id]').val(employee_id);
                    $form_add_negotiation.find('[name=help_request_id]').val('');
                    $form_add_negotiation.find('[name=help_application_id]').val('');
                    $form_add_negotiation.find('[name=employee_help_request_id]').val('');
                    $form_add_negotiation.find('[name=employee_help_application_id]').val('');
                    $form_add_negotiation.find('[name=work_date]').val(work_date);
                    $form_add_negotiation.find('[name=origin_work_time_from]').val(work_time_from);
                    $form_add_negotiation.find('[name=origin_work_time_to]').val(work_time_to);
                    $form_add_negotiation.find('[name=type]').val(type);
                    $form_add_negotiation.find('[name=mode]').val(mode);
                    $form_add_negotiation.find('[name=update_datetime]').val(now);
                    $modal_add_negotiation.find('.message').html(html);
                    $modal_message_index.css('z-index', z_idx_back);
                    $modal_add_negotiation.modal('show');
                    if ($('.modal-backdrop').length > 1) {
                        $('.modal-backdrop')[1].remove();
                    }
                })
                .catch(err => {
                    console.log(err);
                    alert(err);
                })
                .finally(() => {
                    $(this).html(btn_html);
                    $btn.prop('disabled', false);
                })
            // yes, no
            } else {
                $btn.prop('disabled', true);
                $(this).html(spinner);
                axios.get(`${VALIDATE_STORE_NEGOTIATION_API_ENDPOINT}?${params.toString()}`)
                .then(res => {
                    axios.get(`${SET_NEGOTIATION_API_ENDPOINT}?${params.toString()}`)
                    .then(res => {
                        $(this).html(btn_html);
                        $btn.prop('disabled', false);
                        makeThread();
                    })
                    .catch(err => {
                        console.log(err);
                        alert(err);
                        $(this).html(btn_html);
                        $btn.prop('disabled', false);
                    })
                    .finally(() => {

                    })
                })
                .catch(err => {
                    const errors = err.response.data.errors;
                    console.log(errors);
                    let html = `<ul>\n`;
                    $.each(errors, function(k, v) {
                        html += `<li>${v}</li>\n`;
                    })
                    html += `</ul>\n`;
                    $modal_validation.find('.modal-validation-body').html(html);
                    $modal_message_index.css('z-index', z_idx_back);
                    $modal_validation.modal('show');
                    $(this).html(btn_html);
                    $btn.prop('disabled', false);
                })
                .finally(() => {
                })
            }
        // general (yes, no, change)
        } else {
            const tab_class = $form_message_list.find('[name=tab_class]').val(),
                sender_id = $li.attr('data-sender_id'),
                sender_name = $li.find('.sender-name').text(),
                main_tag = $li.attr('data-main_tag'),
                message = (mode === 'yes') ? `はい\n` : ((mode === 'no') ? `いいえ\n` : `その他\n`);
            $form_add_message.find('.edit-message-tag').find('button').hide();
            $(`#btn-message-tag-${main_tag}`).show();
            $('#btn-show-sub-tags').show();
            $form_add_message.find('.destination').text(`@${sender_name}`);
            $form_add_message.find('[name=reply_limit_date]').val('');
            $form_add_message.find('[name=reply_limit_time]').val('');
            $form_add_message.find('.reply-limit').hide();
            $form_add_message.find('[name=message_body]').val(message);
            $form_add_message.find('[name=message_id]').val(message_id);
            $form_add_message.find('[name=tab_class]').val(tab_class);
            $form_add_message.find('[name=destination_ids]').val(sender_id);
            $form_add_message.find('[name=message_tag]').val(main_tag);
            $form_add_message.find('[name=mode]').val(mode);
            $modal_add_message.find('.modal-header').find('h5').text('返信メッセージ作成');
            $modal_message_index.css('z-index', z_idx_back);
            $modal_add_message.modal('show');
            if ($('.modal-backdrop').length > 1) {
                $('.modal-backdrop')[1].remove();
            }
        }
    });

    // 再交渉 閉じる
    $modal_add_negotiation.on('hide.bs.modal', function() {
        $modal_message_index.css('z-index', z_idx_top);
    });

    //可 不可 閉じる
    $modal_validation.on('hide.bs.modal', function(){
        $modal_message_index.css('z-index',z_idx_top);
    })

    // 再交渉モーダル 実行
    $modal_add_negotiation.find('.modal-footer').find('.save').on('click', function() {
        const $form_data = new FormData($form_add_negotiation.get(0)),
            params = new URLSearchParams($form_data),
            $btn = $('button'),
            btn_html = $(this).html();
        $btn.prop('disabled', true);
        $(this).html(spinner);
        axios.get(`${VALIDATE_STORE_NEGOTIATION_API_ENDPOINT}?${params.toString()}`)
        .then(res => {
            const type = $form_add_negotiation.find('[name=type]').val();
            $form_add_negotiation.find('.is-invalid').removeClass('is-invalid');
            $form_add_negotiation.find('.invalid-feedback').text('');
            $modal_add_negotiation.find('.exec-result-message').html('').hide();
            let ret = confirm('交渉を送信します。よろしいですか？');
            if (ret) {
                if (type === 'message') {
                    axios.get(`${SET_NEGOTIATION_API_ENDPOINT}?${params.toString()}`)
                    .then(res => {
                        $modal_add_negotiation.css('z-index', z_idx_back);
                        modal_result.modal('show');
                        if ($('.modal-backdrop').length > 1) {
                            $('.modal-backdrop')[1].remove();
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        alert(err);
                    })
                    .finally(() => {
                        $(this).html(btn_html);
                        $btn.prop('disabled', false);
                    });
                } else {
                    if ($form_add_negotiation.find('[name="view"]').val() === 'dayly') {
                        // フラグをクリア
                        $form_add_negotiation.find('[name="view"]').val('');

                        // 交渉を登録する
                        axios.get(`${SET_HELP_APPLICATION_API_ENDPOINT}?${params.toString()}`)
                        // 成功
                        .then(res => {
                            // 戻り値を取得
                            const data = res.data,
                                help_request_id = data.help_request_id,
                                help_data = data.help_data;

                            // 要素を取得
                            const $div = $(`div.div-help-bar[data-help_request_id="${help_request_id}"]`);

                            // パラメータを設定
                            $div.attr('data-status', help_data.status)
                                .attr('data-last_update_datetime', help_data.last_update_datetime)
                                .attr('data-negotiation_from_employee', '')
                                .attr('data-negotiation_from_organization', '1')
                                .attr('data-help_application_id', help_data.help_application_id);

                            // 結果を表示
                            const message = `<div class="flash_message alert alert-success auto-show-hide">再交渉を送信しました。</div>`;

                            $modal_add_negotiation.modal('hide');
                            $modal_check_negotiation.modal('hide');
                            setTimeout(function() {
                                $flash_message.find('.auto-show-hide').remove();
                                $flash_message.append(message);
                                $flash_message.find('.auto-show-hide').slideDown();
                            }, auto_show_time);
                            setTimeout(function() {
                                $flash_message.find('.auto-show-hide').slideUp();
                            }, auto_hide_time);
                        })
                        // 失敗
                        .catch(err => {
                            // 実行時エラー対応
                            console.log(err);
                            alert(err);
                        })
                        // 終了後
                        .finally(() => {
                            // ボタンを有効化
                            $(this).html(btn_html);
                            $btn.prop('disabled', false);
                        })
                    } else {
                        $form_add_negotiation.submit();
                    }
                }
            } else {
                $(this).html(btn_html);
                $btn.prop('disabled', false);
            }
        })
        .catch(err => {
            const errors = err.response.data.errors;
            console.log(errors);
            let html = `<ul>\n`;
            $form_add_negotiation.find('.is-invalid').removeClass('is-invalid');
            $form_add_negotiation.find('.invalid-feedback').text('');
            $.each(errors, function(k, v) {
                const id = $form_add_negotiation.find(`[name=${k}]`).attr('id');
                $form_add_negotiation.find(`[name=${k}]`).addClass('is-invalid');
                if (id === undefined) {
                    html += `<li>${v}</li>\n`;
                } else {
                    html += `<li><a href="#${id}" class="alert-link">${v}</a></li>\n`;
                }
            })
            html += `</ul>\n`;
            $modal_add_negotiation.find('.exec-result-message').html(html).show();
            $(this).html(btn_html);
            $btn.prop('disabled', false);
        })
        .finally(() => {
        })
    });

    // 返信ボタンクリック
    $(document).on('click', '.btn-reply', function() {
        if (can_not_edit) {
            return false;
        }

        const $li = $(this).closest('li'),
            message_id = $li.attr('data-message_id'),
            mode = 'reply',
            tab_class = $form_message_list.find('[name=tab_class]').val(),
            message_group_id = $form_message_preview.find('[name=message_group_id]').val(),
            sender_id = $li.attr('data-sender_id'),
            sender_name = $li.find('.sender-name').text(),
            destination_name = $li.find('.destination-name').find('span').text(),
            main_tag = $li.attr('data-main_tag'),
            message = '';
        $modal_add_message.find('.exec-result-message').html('').hide();
        $form_add_message.find('.is-invalid').removeClass('is-invalid');
        $form_add_message.find('.invalid-feedback').text('');
        $form_add_message.find('.edit-message-tag').find('button').hide();
        $(`#btn-message-tag-${main_tag}`).show();
        if (main_tag !== '1') {
            $('#btn-show-sub-tags').show();
        }
        if (message_group_id === '') {
            $form_add_message.find('.destination').text(`@${sender_name}`);
            $form_add_message.find('[name=destination_ids]').val(sender_id);
        } else {
            $form_add_message.find('.destination').text(destination_name);
            $form_add_message.find('[name=destination_ids]').val(message_group_id);
        }
        $form_add_message.find('[name=reply_limit_date]').val('');
        $form_add_message.find('[name=reply_limit_time]').val('');
        $form_add_message.find('.reply-limit').hide();
        $form_add_message.find('[name=message_body]').val(message);
        $form_add_message.find('[name=message_id]').val(message_id);
        $form_add_message.find('[name=tab_class]').val(tab_class);
        $form_add_message.find('[name=message_tag]').val(main_tag);
        $form_add_message.find('[name=mode]').val(mode);
        $modal_add_message.find('.modal-header').find('h5').text('返信メッセージ作成');
        $modal_add_message.find('.modal-footer').find('.save').addClass('disabled').prop('disabled', true);
        $modal_message_index.css('z-index', z_idx_back);
        $modal_add_message.modal('show');
        if ($('.modal-backdrop').length > 1) {
            $('.modal-backdrop')[1].remove();
        }
    });

    // 新規作成クリック
    $('.btn-show-message-add').on('click', function() {
        const disabled = $(this).hasClass('disabled'),
            inactive = $(this).hasClass('inactive'),
            $checked = $form_message_list.find('input[type=checkbox]:checked');
        if (!disabled) {
            if (!inactive) {
                if ($checked.length === 0) {
                    alert('メッセージ送信対象を選択してください。');
                } else {
                    $modal_add_message.find('.exec-result-message').html('').hide();
                    $form_add_message.find('.is-invalid').removeClass('is-invalid');
                    $form_add_message.find('.invalid-feedback').text('');
                    const tab_class = $form_message_list.find('[name=tab_class]').val();
                    let destination_ids = '',
                        destination_names = '@';
                    $.when(
                        $checked.each(function() {
                            const this_id = $(this).val(),
                                $tr = $(this).closest('tr'),
                                this_name = $tr.find('.name').text();
                            destination_ids += (destination_ids !== '') ? `,${this_id}` : this_id;
                            destination_names += (destination_names !== '@') ? ` , ${this_name}` : this_name;
                        })
                    ).done(function() {
                        $form_add_message.find('.edit-message-tag').find('button').hide();
                        $('#btn-show-main-tags').show();
                        $form_add_message.find('.destination').text(destination_names);
                        $form_add_message.find('[name=reply_limit_date]').val('');
                        $form_add_message.find('[name=reply_limit_time]').val('');
                        $form_add_message.find('.reply-limit').hide();
                        $form_add_message.find('[name=message_body]').val('');
                        $form_add_message.find('[name=message_id]').val('');
                        $form_add_message.find('[name=message_tag]').val('');
                        $form_add_message.find('[name=message_tag_sub]').val('');
                        $form_add_message.find('[name=tab_class]').val(tab_class);
                        $form_add_message.find('[name=destination_ids]').val(destination_ids);
                        $form_add_message.find('[name=mode]').val('');
                        $modal_add_message.find('.modal-header').find('h5').text('新規メッセージ作成');
                        $modal_add_message.find('.modal-footer').find('.save').addClass('disabled').prop('disabled', true);
                        $modal_message_index.css('z-index', z_idx_back);
                        $modal_add_message.modal('show');
                        if ($('.modal-backdrop').length > 1) {
                            $('.modal-backdrop')[1].remove();
                        }
                    });
                }
            }
        }
    });

    // 新規作成閉じる
    $modal_add_message.on('hide.bs.modal', function() {
        $modal_message_index.css('z-index', z_idx_top);
    });

    // タグ追加クリック (メインタグ)
    $('#btn-show-main-tags').on('click', function(e) {
        const top = e.target.clientTop + e.target.offsetHeight,
            left = e.target.clientLeft + e.target.offsetLeft;
        $('#dropdown-menu-main-tags').find('button').show();
        $('#dropdown-menu-main-tags').css('top', top).css('left', left).show();
    });

    // タグクリック (メインタグ)
    $('#btn-message-tag-2, #btn-message-tag-3, #btn-message-tag-4').on('click', function(e) {
        const mode = $form_add_message.find('[name=mode]').val(),
            top = e.target.clientTop + e.target.offsetHeight,
            left = e.target.clientLeft + e.target.offsetLeft;
        if (mode === '') {
            $('#dropdown-menu-main-tags').find('button').show();
            $('#dropdown-menu-main-tags').css('top', top).css('left', left).show();
        }
    });

    // メインタグ追加
    $('#dropdown-menu-main-tags').find('button').on('click', function() {
        const message_tag = $(this).attr('data-message_tag'),
            message_tag_sub = $form_add_message.find('[name=message_tag_sub]').val(),
            message_body = $form_add_message.find('[name=message_body]').val();
        $('#btn-show-main-tags').hide();
        $('.edit-message-tag').find('.main').hide();
        $(`#btn-message-tag-${message_tag}`).show();
        if (message_tag_sub === '') {
            $('#btn-show-sub-tags').show();
        }
        $form_add_message.find('[name=message_tag]').val(message_tag);
        $('#dropdown-menu-main-tags').hide();
        if (message_body) {
            $modal_add_message.find('.modal-footer').find('.save').removeClass('disabled').prop('disabled', false);
        } else {
            if (!$modal_add_message.find('.modal-footer').find('.save').hasClass('disabled')) {
                $modal_add_message.find('.modal-footer').find('.save').addClass('disabled').prop('disabled', true);
            }
        }
    });

    // 枠外クリックでドロップダウンメニュー閉じる (メインタグ)
    $(document).on('click', function(e) {
        if (!$(e.target).closest('#dropdown-menu-main-tags').length && !$(e.target).closest('#btn-show-main-tags').length && !$(e.target).closest('#btn-message-tag-2').length && !$(e.target).closest('#btn-message-tag-3').length && !$(e.target).closest('#btn-message-tag-4').length) {
            $('#dropdown-menu-main-tags').hide();
        }
    });

    // タグ追加クリック (サブタグ)
    $('#btn-show-sub-tags').on('click', function(e) {
        const top = e.target.clientTop + e.target.offsetHeight,
            left = e.target.clientLeft + e.target.offsetLeft;
        $('#dropdown-menu-sub-tags').find('button').show();
        $('#dropdown-menu-sub-tags').find('.message-tag-0').hide();
        $('#dropdown-menu-sub-tags').css('top', top).css('left', left).show();
    });

    // サブタグ追加
    $('#dropdown-menu-sub-tags').find('button').on('click', function() {
        const message_tag_sub = $(this).attr('data-message_tag_sub');
        $('.edit-message-tag').find('.sub').hide();
        if (message_tag_sub === '0') {
            $('#btn-show-sub-tags').show();
            $form_add_message.find('.reply-limit').hide();
            $form_add_message.find('[name=message_tag_sub]').val('');
        } else {
            $form_add_message.find('.reply-limit').show();
            $('#btn-show-sub-tags').hide();
            $(`#btn-message-tag-${message_tag_sub}`).show();
            $form_add_message.find('[name=message_tag_sub]').val(message_tag_sub);
        }
        $('#dropdown-menu-sub-tags').hide();
    });

    // タグクリック (サブタグ)
    $('#btn-message-tag-8, #btn-message-tag-9').on('click', function(e) {
        const top = e.target.clientTop + e.target.offsetHeight,
            left = e.target.clientLeft + e.target.offsetLeft;
        $('#dropdown-menu-sub-tags').find('button').show();
        $('#dropdown-menu-sub-tags').css('top', top).css('left', left).show();
    });

    // 枠外クリックでドロップダウンメニュー閉じる (サブタグ)
    $(document).on('click', function(e) {
        if (!$(e.target).closest('#dropdown-menu-sub-tags').length && !$(e.target).closest('#btn-show-sub-tags').length && !$(e.target).closest('#btn-message-tag-8').length && !$(e.target).closest('#btn-message-tag-9').length) {
            $('#dropdown-menu-sub-tags').find('button').show();
            $('#dropdown-menu-sub-tags').hide();
        }
    });

    // 本文入力
    $('#message-body').on('keypress keyup change', function(e) {
        const message_tag = $form_add_message.find('[name=message_tag]').val(),
            message_body = $form_add_message.find('[name=message_body]').val();
        if (message_tag && message_body) {
            $modal_add_message.find('.modal-footer').find('.save').removeClass('disabled').prop('disabled', false);
        } else {
            if (!$modal_add_message.find('.modal-footer').find('.save').hasClass('disabled')) {
                $modal_add_message.find('.modal-footer').find('.save').addClass('disabled').prop('disabled', true);
            }
        }
    });

    // 送信
    $modal_add_message.find('.save').on('click', function(e) {
        const form_data = new FormData($form_add_message.get(0)),
            params = new URLSearchParams(form_data),
            $btn = $('button'),
            btn_html = $(this).html();
        $btn.prop('disabled', true);
        $(this).html(spinner);
        axios.get(`${VALIDATE_STORE_MESSAGE_API_ENDPOINT}?${params.toString()}`)
        .then(res => {
            $modal_add_message.find('.exec-result-message').html('').hide();
            $form_add_message.find('.is-invalid').removeClass('is-invalid');
            $form_add_message.find('.invalid-feedback').text('');
            axios.get(`${SET_MESSAGE_API_ENDPOINT}?${params.toString()}`)
            .then(res => {
                $modal_add_message.css('z-index', z_idx_back);
                modal_result.modal('show');
                if ($('.modal-backdrop').length > 1) {
                    $('.modal-backdrop')[1].remove();
                }
            })
            .catch(err => {
                console.log(err);
                alert(err);
            })
            .finally(() => {
                $(this).html(btn_html);
                $btn.prop('disabled', false);
            })
        })
        .catch(err => {
            const errors = err.response.data.errors;
            console.log(errors);
            let html = `<ul>\n`;
            $form_add_message.find('.is-invalid').removeClass('is-invalid');
            $form_add_message.find('.invalid-feedback').text('');
            $.each(errors, function(k, v) {
                const id = $form_add_message.find(`[name=${k}]`).attr('id');
                switch (k) {
                    case 'message_tag':
                        $('.edit-message-tag').find('.invalid-feedback').text(v);
                        html += `<li>${v}</li>\n`;
                        break;
                    case 'reply_limit_date':
                    case 'reply_limit_time':
                        $form_add_message.find(`[name=${k}]`).addClass('is-invalid');
                        $('.reply-limit').find('.invalid-feedback').text(v).show();
                        html += `<li><a href="#${id}" class="alert-link">${v}</a></li>\n`;
                        break;
                    default:
                        $form_add_message.find(`[name=${k}]`).addClass('is-invalid');
                        $form_add_message.find(`[name=${k}]`).next().text(v);
                        if (id === undefined) {
                            html += `<li>${v}</li>\n`;
                        } else {
                            html += `<li><a href="#${id}" class="alert-link">${v}</a></li>\n`;
                        }
                        break;
                }
            })
            html += `</ul>\n`;
            $modal_add_message.find('.exec-result-message').html(html).show();
            $(this).html(btn_html);
            $btn.prop('disabled', false);
        })
        .finally(() => {
        })
    });

    // 完了閉じる
    modal_result.on('hide.bs.modal', function() {
        const message_group_id = $form_message_list.find('[name=message_group_id]').val(),
            employee_id = $form_message_list.find('[name=employee_id]').val();
        $modal_add_message.css('z-index', z_idx_top);
        $modal_add_message.modal('hide');
        $modal_add_negotiation.css('z-index', z_idx_top);
        $modal_add_negotiation.modal('hide');
        if (message_group_id !== '' || employee_id !== '') {
            makeThread();
        }
    });
});

/**
 * メッセージ一覧表作成
 *
 * @param {object|null} obj 対象オブジェクト
 * @return {void}
 * @author hayakawa 2022.04.18
 */
let makeMessageList = (obj = null) => {
    const sort_target = $form_message_list.find('[name=sort_target]').val(),
        sort_mode = $form_message_list.find('[name=sort_mode]').val(),
        $form_data = new FormData($form_message_list.get(0)),
        params = new URLSearchParams($form_data),
        $btn = $('button'),
        $a = $modal_message_index.find('a');
    $btn.prop('disabled', true);
    $a.addClass('disabled');
    if (obj !== null) {
        var btn_html = obj.html();
        obj.html(spinner);
    }
    axios.get(`${GET_MESSAGES_API_ENDPOINT}?${params.toString()}`)
    .then(res => {
        const data = res.data,
            message_list = data.message_list,
            tab_count_list = data.tab_count_list,
            filter_count_list = data.filter_count_list,
            tab_class = data.tab_class,
            filter_class = data.filter_class;
        let html = '';
        // obj
        if (obj !== null) {
            obj.html(btn_html);
        }
        // tabs
        $section_message_tabs.find('button').removeClass('active');
        $section_message_tabs.find(`[data-tab=${tab_class}]`).addClass('active');
        $.each(tab_count_list, function(k, v) {
            if (v) {
                $section_message_tabs.find(`[data-tab=${k}]`).find('.unread-mark').show();
            } else {
                $section_message_tabs.find(`[data-tab=${k}]`).find('.unread-mark').hide();
            }
        });
        // buttons
        $section_message_buttons.find('.unread').find('.counts').text((filter_count_list.unread > 9) ? '9+' : filter_count_list.unread);
        $section_message_buttons.find('.help').find('.counts').text((filter_count_list.help > 9) ? '9+' : filter_count_list.help);
        $section_message_buttons.find('.attendance').find('.counts').text((filter_count_list.attendance > 9) ? '9+' : filter_count_list.attendance);
        $section_message_buttons.find('.contact').find('.counts').text((filter_count_list.contact > 9) ? '9+' : filter_count_list.contact);
        $section_message_buttons.find('.freetalk').find('.counts').text((filter_count_list.freetalk > 9) ? '9+' : filter_count_list.freetalk);
        $section_message_buttons.find('button').removeClass('active');
        $section_message_buttons.find(`.${filter_class}`).addClass('active');
        // message_list (head)
        $(`.table-message-index-${tab_class}`).find('thead').find('button').hide();
        $(`.table-message-index-${tab_class}`).find('thead').find('.active').removeClass('active');
        // message_list (head sort)
        if (sort_target === 'name') {
            $(`.table-message-index-${tab_class}`).find('thead').find(`.btn-sort-${sort_mode}[data-target=name]`).show();
            $(`.table-message-index-${tab_class}`).find('thead').find('.btn-sort-[data-target=date]').show();
            if (sort_mode !== '') {
                $(`.table-message-index-${tab_class}`).find('thead').find('.name').addClass('active');
            }
        } else if (sort_target === 'date') {
            $(`.table-message-index-${tab_class}`).find('thead').find(`.btn-sort-${sort_mode}[data-target=date]`).show();
            $(`.table-message-index-${tab_class}`).find('thead').find('.btn-sort-[data-target=name]').show();
            if (sort_mode !== '') {
                $(`.table-message-index-${tab_class}`).find('thead').find('.date').addClass('active');
            }
        } else {
            $(`.table-message-index-${tab_class}`).find('thead').find('.btn-sort-').show();
        }
        // message_list (body)
        message_list.forEach(v => {
            const this_id = (tab_class === 'group') ? v.message_group_id : v.employee_id,
                this_name = (tab_class === 'group') ? v.message_group_name : v.employee_name;
            let tr = '' +
            `<tr data-target_id="${this_id}">\n` +
                `<td class="text-center">\n`;
            if (v.is_marked) {
                tr += `<span class="unread-mark">未読</span>\n`;
            }
            tr += '' +
                `</td>\n` +
                `<td class="text-left name">${this_name}</td>\n`;
            if (tab_class === 'pj') {
                const this_belong_class = (v.is_pj) ? 'pj' : 'other',
                    this_belong_str =  (v.is_pj) ? 'PJ' : '+crew';
                tr += '' +
                `<td class="text-center">\n` +
                    `<div class="belongs ${this_belong_class}">${this_belong_str}</div>\n` +
                `</td>\n`;
            }
            tr += '' +
                `<td class="text-left">${v.last_datetime_str}</td>\n` +
                `<td class="text-center">\n` +
                    `<div class="chk-custom">` +
                        `<input type="checkbox" class="" id="${tab_class}-${this_id}" name="${tab_class}_${this_id}" value="${this_id}">\n` +
                        `<label for="${tab_class}-${this_id}"></label>` +
                    `</div>` +
                `</td>\n` +
            `</tr>\n`;
            html += $(tr).prop('outerHTML');
        });
        $section_message_list.find('table').hide();
        $(`.table-message-index-${tab_class}`).find('tbody').html(html);
        $(`.table-message-index-${tab_class}`).show();
        // right
        $section_message_preview.hide();
        $section_message_tips.show();
        // modal
        $form_message_list.find('[name=message_group_id]').val('');
        $form_message_list.find('[name=employee_id]').val('');
        $form_message_list.find('[name=filter_class]').val(filter_class);
        $form_message_list.find('[name=tab_class]').val(tab_class);
        $modal_message_index.modal('show');
    })
    .catch(err => {
        console.log(err);
        alert(err);
    })
    .finally(() => {
        $a.removeClass('disabled');
        $btn.prop('disabled', false);
        resetModeCheckBox();
    })
};

/**
 * スレッド作成
 *
 * @param {object|null} obj 対象オブジェクト
 * @return {void}
 * @author hayakawa 2022.04.19
 */
let makeThread = (obj = null) => {
    const $form_data = new FormData($form_message_list.get(0)),
        params = new URLSearchParams($form_data),
        $btn = $('button'),
        $a = $modal_message_index.find('a');
    $btn.prop('disabled', true);
    $a.addClass('disabled');
    axios.get(`${GET_THREAD_API_ENDPOINT}?${params.toString()}`)
    .then(res => {
        const thread = res.data,
            now = getNow();
        let html = '',
            prev_ymd = '',
            prev_read = null;
        $.each(thread, function(k, v) {
            // param
            const root_message_id = (v.root_message_id === null) ? '' : v.root_message_id;
            let class_str = (v.is_sender_self) ? 'sender-self' : 'sender-other';
            class_str += (v.has_root) ? ' has-root' : '';
            // 処理
            if (prev_ymd === '') {
                html += '' +
                `<ul class="message-display-month">\n`;
            } else if (prev_ymd !== v.send_datetime_ymd) {
                html += '' +
                `</ul>\n` +
                `<div class="date-border">\n` +
                    `<p class="">${prev_ymd}</p>\n` +
                `</div>\n` +
                `<ul class="message-display-month">\n`;
            }
            if ((prev_read === null || prev_read === true) && v.is_read === false) {
                html += '' +
                `</ul>\n` +
                `<div class="new-border" id="new-border">\n` +
                    `<p class="">新しいメッセージ</p>\n` +
                `</div>\n` +
                `<ul class="message-display-month">\n`;
            }
            html += '' +
                    `<li class="message-item ${class_str}" data-message_id="${v.message_id}" data-root_message_id="${root_message_id}" data-sender_id="${v.sender_id}" data-main_tag="${v.main_tag}" data-work_date="${v.help_work_date_str}">\n` +
                        `<section class="message-item-header">\n`;
            if (v.is_sender_self) {
                html += `<span class="sender-name"></span>\n`;
            } else {
                html += `<span class="sender-name">${v.sender_name}</span>\n`;
            }
            html += `<span class="send-datetime">${v.send_datetime_str}</span>\n`;
            if (v.is_readed) {
                html += `<span class="is-readed">既読${v.readed_number}</span>\n`;
            }
            if (!v.is_sender_self) {
                html += `<span class="sender-initial">${v.sender_initial}</span>\n`;
            }
            html += `</section>\n`;
            if (v.has_root) {
                html += '' +
                        `<section class="root-message">\n` +
                            `<span class="has-root">\n` +
                                `<i class="fas fa-share"></i>\n` +
                            `</span>\n` +
                            `<span class="root-send-datetime">${v.root_send_datetime_str}</span>\n` +
                            `<span class="root-sender-name">${v.root_sender_name}</span>\n` +
                        `</section>`;
            }
            html += '' +
                        `<section class="message-item-body">\n` +
                            `<section class="message-item-info">\n`;
            if (v.has_tree) {
                html += '' +
                                `<span class="has-tree">\n` +
                                    `<i class="fas fa-share"></i>\n` +
                                `</span>\n`;
            }
            $.each(v.message_tags, function(k2, v2) {
                html += `<span class="message-tag message-tag-${v2.no}">${v2.name}</span>\n`;
            });
            html += '' +
                            `</section>\n` +
                            `<section class="destination-name">\n` +
                                `<span class="">${v.destination_name}</span>\n` +
                            `</section>\n` +
                            `<section class="">\n` +
                                `<ul class="list-style-none p-0">\n`;
            $.each(v.messages, function(k2, v2) {
                html += `<li>${v2}</li>\n`;
            });
            html += '' +
                                `</ul>\n` +
                            `</section>\n`;
            if (v.answer_timelimit_str) {
                html += '' +
                            `<section class="reply-limit-date">` +
                                `返信期限：${v.answer_timelimit_str}` +
                            `</section>`;
            }
            if (v.is_answer_show) {
                if (v.is_sender_self) {
                    if (v.has_unreplied) {
                        html += `<section class="answer-message confirm">確認中</section>\n`;
                    }
                } else {
                    html += `<section class="answer-buttons">\n`;
                    if (v.answer_class === answer_class_help) {
                        html += '' +
                                `<button type="button" class="btn btn-sm yes help">可</button>\n` +
                                `<button type="button" class="btn btn-sm no help">不可</button>\n` +
                                `<button type="button" class="btn btn-sm change help">再交渉</button>\n`;
                    } else if (v.answer_class === answer_class_only_reply) {
                        html += `<button type="button" class="btn btn-sm btn-answer-reply">返信</button>\n`;
                    } else if (v.answer_class === answer_class_three_choices) {
                        html += '' +
                                `<button type="button" class="btn btn-sm no">いいえ</button>\n` +
                                `<button type="button" class="btn btn-sm yes">はい</button>\n` +
                                `<button type="button" class="btn btn-sm change">その他</button>\n`;
                    }
                    html += `</section>\n`;
                }
            } else if (v.is_answer_over) {
                html += `<section class="answer-message over">返信期限が過ぎました</section>\n`;
            } else if (v.is_answer_yes) {
                html += '' +
                            `<section class="answer-message yes">\n` +
                                `<i class="fas fa-check mr-2"></i>\n`;
                if (v.is_sender_self) {
                    html += `承認されました\n`;
                } else {
                    html += `承認しました\n`;
                }
                html += `</section>\n`;
            } else if (v.is_answer_no) {
                html += `<section class="answer-message no">`;
                if (v.is_sender_self) {
                    html += `辞退されました`;
                } else {
                    html += `辞退しました`;
                }
                html += `</section>\n`;
            } else if (v.is_answer_other) {
                html += `<section class="answer-message other">`;
                if (v.is_sender_self) {
                    html += `返信されました`;
                } else {
                    html += `返信しました`;
                }
                html += `</section>\n`;
            } else if (v.is_answer_others_have_replied) {
                html += `<section class="answer-message others-have-replied">`;
                html += `別な方が返信しました`;
                html += `</section>\n`;
            }
            html += `</section>\n`;
            if (v.is_group || !v.is_sender_self) {
                html += `<button type="button" class="btn-reply">\n` +
                            `<img src="/images/icon/reply_web.svg">\n` +
                        `</button>\n`;
            }
            html += `</li>\n`;
            prev_ymd = v.send_datetime_ymd;
            if (v.is_read !== null) {
                prev_read = v.is_read;
            }
        });
        html += `</ul>\n`;
        $section_message_display.html(html);
        $form_message_preview.find('[name=message_id]').val('');
        $form_message_preview.find('[name=mode]').val('');
        $form_message_preview.find('[name=set_message_readed]').val('');
        $form_message_preview.find('[name=update_datetime]').val(now);
        $section_message_tips.hide();
        $section_message_preview.show();
        if ($('#new-border').length > 0) {
            const position = $('#new-border').offset().top - 100;
            $section_message_preview.animate({scrollTop: position}, 0);
        } else {
            $section_message_preview.animate({scrollTop: $section_message_display[0].scrollHeight}, 0);
        }
        // 既読処理
        setTimeout(function() {
            setMessageReaded();
        }, 500);
    })
    .catch(err => {
        console.log(err);
        alert(err);
    })
    .finally(() => {
        $a.removeClass('disabled');
        $btn.prop('disabled', false);
    })
}

/**
 * 既読処理
 *
 * @return {void}
 * @author hayakawa 2021.12.02
 */
let setMessageReaded = () => {
    const organization_id = $form_message_preview.find('[name=organization_id]').val(),
        employee_id = $form_message_preview.find('[name=employee_id]').val(),
        message_group_id = $form_message_preview.find('[name=message_group_id]').val(),
        set_message_readed = $form_message_preview.find('[name=set_message_readed]').val(),
        params = new URLSearchParams();
    if (set_message_readed === '') {
        params.append('organization_id', organization_id);
        params.append('message_group_id', message_group_id);
        params.append('employee_id', employee_id);
        axios.get(`${SET_MESSAGE_READED_API_ENDPOINT}?${params.toString()}`)
        .then(res => {
            $form_message_preview.find('[name=set_message_readed]').val('1');
        })
        .catch(err => {
            console.log(err);
            alert(err);
        })
        .finally(() => {
        })
    }
}

/**
 * 新規作成ボタンの活性非活性制御
 *
 * @return {void}
 * @author hayakawa 2023.10.25
 */
let controlBtnActivate = () => {
    const tab_class = $form_message_list.find('input[name=tab_class]').val(),
        $table = $section_message_list.find(`table.table-message-index-${tab_class}`),

    $checked = $table.find('input[type=checkbox]:checked');
    if (!can_not_edit) {
        if ($checked.length === 0) {
            if (!$('.btn-show-message-add').hasClass('inactive')) {
                $('.btn-show-message-add').addClass('inactive');
                $('.btn-show-message-add').find('.img-active').hide();
                $('.btn-show-message-add').find('.img-inactive').show();
            }
        } else {
            if ($('.btn-show-message-add').hasClass('inactive')) {
                $('.btn-show-message-add').removeClass('inactive');
                $('.btn-show-message-add').find('.img-active').show();
                $('.btn-show-message-add').find('.img-inactive').hide();
            }
        }
    }
}

/**
 * 選択モードとチェックボックスの初期化
 *
 * @return {void}
 * @author hayakawa 2022.04.12
 */
let resetModeCheckBox = () => {
    const $button = $('a.btn-show-message-add'),
        $tables = $section_message_list.find('table'),
        $buttons = $tables.find('a.btn-change-select-mode'),
        $checkboxs = $tables.find('input[type=checkbox]');
    $button.addClass('inactive');
    $button.find('.img-active').hide();
    $button.find('.img-inactive').show();
    $buttons.addClass('inactive');
    $buttons.find('.img-active').hide();
    $buttons.find('.img-inactive').show();
    $checkboxs.prop('checked', false).addClass('invisible');
    $form_message_list.find('[name=select_mode]').val('');
}

/**
 * 現在時刻(YYYY-mm-dd HH:ii:ss)取得
 *
 * @return {string}
 * @author hayakawa 2022.01.26
 */
let getNow = () => {
    const d = new Date(),
        year = d.getFullYear(),
        month = d.getMonth() + 1,
        day = d.getDate(),
        hour = d.getHours(),
        minute = d.getMinutes(),
        second = d.getSeconds(),
        now = year + '-' +
        ('0' + month).slice(-2) + '-' +
        ('0' + day).slice(-2) + ' ' +
        ('0' + hour).slice(-2) + ':' +
        ('0' + minute).slice(-2) + ':' +
        ('0' + second).slice(-2);
    return now;
}
